import instance from '@/services/repository';

const resource = '/machinery/Events';

export default {
    lookup(options: any, machineryId: string, begin?: string, end?: string) {
        const formData = new FormData();

        for ( const key in options ) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        const query = machineryId ? '?machineryId=' + machineryId : '';

        return instance
            .post(`${resource}/lookup${query}`,
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data' },
                });
    },
    getSingle(id: string) {
        return instance.get<IMachineryEvent>(`${resource}/${id}`);
    },
    create(payload: IMachineryCreateEventCommand) {
        return instance.post<IMachineryEvent>(`${resource}`, payload);
    },
    update(payload: IMachineryUpdateEventCommand) {
        return instance.put<IMachineryEvent>(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    getImages(id: string) {
        return instance.get<any[]>(`${resource}/${id}/images`);
    },
};
